import React, { useState } from "react";
import { Box, Flex } from "@chakra-ui/react";
// import { useLocation, useNavigate } from "react-router-dom";
import Login from "./Login";
import Register from "./Register";
import { Button } from "@chakra-ui/react";

export const AuthModal: React.FC = () => {
  const [isLogin, setIsLogin] = useState(true);

  return (
    <Box
      minH="100vh"
      bg="linear-gradient(135deg, #1e3a8a 0%, #3b82f6 50%, #60a5fa 100%)"
      position="relative"
    >
      {/* Top-right switch button */}
      <Box position="absolute" top={4} right={4}>
        <Button
          size="sm"
          variant="outline"
          color="white"
          borderColor="whiteAlpha.400"
          bg="whiteAlpha.200"
          _hover={{ bg: "whiteAlpha.300" }}
          onClick={() => setIsLogin(!isLogin)}
        >
          Switch to {isLogin ? "Register" : "Login"}
        </Button>
      </Box>

      {/* Centered content */}
      <Flex minH="100vh" align="center" justify="space-around">
        <Box
          w={["100%", "100%", "50%"]}
          maxW="md"
          p={4}
          marginTop={["18%", "18px", "0px"]}
          borderRadius="xs"
          bg="transparent"
          boxShadow="xl"
        >
          {isLogin ? <Login /> : <Register />}
        </Box>
      </Flex>
    </Box>
  );
};

// // Login Component
// export const LoginForm: React.FC<{ onSwitchToRegister: () => void }> = ({
//   onSwitchToRegister,
// }) => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");

//   const handleLogin = () => {
//     // Simulate login
//     alert("Login Successful! Welcome back to BBPS!");
//   };

//   return (
//     <Box
//       p={8}
//       bg="rgba(255,255,255,0.95)"
//       borderRadius="2xl"
//       shadow="2xl"
//       backdropFilter="blur(20px)"
//       border="1px solid rgba(255,255,255,0.2)"
//       w="full"
//       maxW="400px"
//       mx="auto"
//     >
//       <VStack gap={6} align="stretch">
//         <Box textAlign="center">
//           <Box
//             p={4}
//             borderRadius="full"
//             bg="linear-gradient(135deg, #1e40af, #3b82f6)"
//             color="white"
//             display="inline-flex"
//             mb={4}
//           >
//             <Icon as={FiShield} boxSize={8} />
//           </Box>
//           <Heading size="lg" color="gray.800" mb={2}>
//             Welcome Back
//           </Heading>
//           <Text color="gray.600">Sign in to your BBPS account</Text>
//         </Box>

//         <VStack gap={4} align="stretch">
//           <Box>
//             <Text color="gray.700" fontWeight="semibold" mb={2}>
//               Email or Phone
//             </Text>
//             <Box position="relative">
//               <Input
//                 type="text"
//                 placeholder="Enter email or phone"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 size="lg"
//                 borderRadius="lg"
//                 bg="white"
//                 shadow="sm"
//                 pl={10}
//               />
//               <Icon
//                 as={FiMail}
//                 position="absolute"
//                 left={3}
//                 top="50%"
//                 transform="translateY(-50%)"
//                 color="gray.400"
//                 boxSize={5}
//               />
//             </Box>
//           </Box>

//           <Box>
//             <Text color="gray.700" fontWeight="semibold" mb={2}>
//               Password
//             </Text>
//             <Box position="relative">
//               <Input
//                 type="password"
//                 placeholder="Enter password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 size="lg"
//                 borderRadius="lg"
//                 bg="white"
//                 shadow="sm"
//                 pl={10}
//               />
//               <Icon
//                 as={FiLock}
//                 position="absolute"
//                 left={3}
//                 top="50%"
//                 transform="translateY(-50%)"
//                 color="gray.400"
//                 boxSize={5}
//               />
//             </Box>
//           </Box>
//         </VStack>

//         <Button
//           bg="linear-gradient(135deg, #1e40af, #3b82f6)"
//           color="white"
//           size="lg"
//           borderRadius="lg"
//           _hover={{
//             bg: "linear-gradient(135deg, #1e3a8a, #2563eb)",
//             transform: "translateY(-2px)",
//             shadow: "lg",
//           }}
//           transition="all 0.2s ease"
//           onClick={handleLogin}
//           disabled={!email || !password}
//         >
//           <HStack gap={2}>
//             <Icon as={FiUser} />
//             <Text>Sign In</Text>
//           </HStack>
//         </Button>

//         <HStack gap={4} align="center">
//           <Box flex={1} h="1px" bg="gray.300" />
//           <Text fontSize="sm" color="gray.500">
//             or
//           </Text>
//           <Box flex={1} h="1px" bg="gray.300" />
//         </HStack>

//         <HStack gap={3}>
//           <Button
//             variant="outline"
//             flex={1}
//             borderRadius="lg"
//             _hover={{
//               bg: "blue.50",
//               borderColor: "blue.500",
//             }}
//           >
//             <HStack gap={2}>
//               <Icon as={FiSmartphone} />
//               <Text fontSize="sm">OTP Login</Text>
//             </HStack>
//           </Button>
//         </HStack>

//         <Text textAlign="center" fontSize="sm" color="gray.600">
//           {"Don't have an account? "}
//           <Button
//             variant="ghost"
//             colorScheme="blue"
//             size="sm"
//             onClick={onSwitchToRegister}
//           >
//             Sign Up
//           </Button>
//         </Text>
//       </VStack>
//     </Box>
//   );
// };

// // Register Component
// export const RegisterForm: React.FC<{ onSwitchToLogin: () => void }> = ({
//   onSwitchToLogin,
// }) => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     password: "",
//     confirmPassword: "",
//   });

//   const handleRegister = () => {
//     if (formData.password !== formData.confirmPassword) {
//       alert("Passwords do not match!");
//       return;
//     }

//     // Simulate registration
//     alert("Registration Successful! Welcome to BBPS!");
//   };

//   return (
//     <Box
//       p={8}
//       bg="rgba(255,255,255,0.95)"
//       borderRadius="2xl"
//       shadow="2xl"
//       backdropFilter="blur(20px)"
//       border="1px solid rgba(255,255,255,0.2)"
//       w="full"
//       maxW="400px"
//       mx="auto"
//     >
//       <VStack gap={6} align="stretch">
//         <Box textAlign="center">
//           <Box
//             p={4}
//             borderRadius="full"
//             bg="linear-gradient(135deg, #059669, #10b981)"
//             color="white"
//             display="inline-flex"
//             mb={4}
//           >
//             <Icon as={FiCheckCircle} boxSize={8} />
//           </Box>
//           <Heading size="lg" color="gray.800" mb={2}>
//             Create Account
//           </Heading>
//           <Text color="gray.600">Join BBPS for seamless bill payments</Text>
//         </Box>

//         <VStack gap={4} align="stretch">
//           <Box>
//             <Text color="gray.700" fontWeight="semibold" mb={2}>
//               Full Name
//             </Text>
//             <Box position="relative">
//               <Input
//                 type="text"
//                 placeholder="Enter your full name"
//                 value={formData.name}
//                 onChange={(e) =>
//                   setFormData({ ...formData, name: e.target.value })
//                 }
//                 size="lg"
//                 borderRadius="lg"
//                 bg="white"
//                 shadow="sm"
//                 pl={10}
//               />
//               <Icon
//                 as={FiUser}
//                 position="absolute"
//                 left={3}
//                 top="50%"
//                 transform="translateY(-50%)"
//                 color="gray.400"
//                 boxSize={5}
//               />
//             </Box>
//           </Box>

//           <Box>
//             <Text color="gray.700" fontWeight="semibold" mb={2}>
//               Email
//             </Text>
//             <Box position="relative">
//               <Input
//                 type="email"
//                 placeholder="Enter your email"
//                 value={formData.email}
//                 onChange={(e) =>
//                   setFormData({ ...formData, email: e.target.value })
//                 }
//                 size="lg"
//                 borderRadius="lg"
//                 bg="white"
//                 shadow="sm"
//                 pl={10}
//               />
//               <Icon
//                 as={FiMail}
//                 position="absolute"
//                 left={3}
//                 top="50%"
//                 transform="translateY(-50%)"
//                 color="gray.400"
//                 boxSize={5}
//               />
//             </Box>
//           </Box>

//           <Box>
//             <Text color="gray.700" fontWeight="semibold" mb={2}>
//               Phone Number
//             </Text>
//             <Box position="relative">
//               <Input
//                 type="tel"
//                 placeholder="Enter phone number"
//                 value={formData.phone}
//                 onChange={(e) =>
//                   setFormData({ ...formData, phone: e.target.value })
//                 }
//                 size="lg"
//                 borderRadius="lg"
//                 bg="white"
//                 shadow="sm"
//                 pl={10}
//               />
//               <Icon
//                 as={FiSmartphone}
//                 position="absolute"
//                 left={3}
//                 top="50%"
//                 transform="translateY(-50%)"
//                 color="gray.400"
//                 boxSize={5}
//               />
//             </Box>
//           </Box>

//           <Box>
//             <Text color="gray.700" fontWeight="semibold" mb={2}>
//               Password
//             </Text>
//             <Box position="relative">
//               <Input
//                 type="password"
//                 placeholder="Create password"
//                 value={formData.password}
//                 onChange={(e) =>
//                   setFormData({ ...formData, password: e.target.value })
//                 }
//                 size="lg"
//                 borderRadius="lg"
//                 bg="white"
//                 shadow="sm"
//                 pl={10}
//               />
//               <Icon
//                 as={FiLock}
//                 position="absolute"
//                 left={3}
//                 top="50%"
//                 transform="translateY(-50%)"
//                 color="gray.400"
//                 boxSize={5}
//               />
//             </Box>
//           </Box>

//           <Box>
//             <Text color="gray.700" fontWeight="semibold" mb={2}>
//               Confirm Password
//             </Text>
//             <Input
//               type="password"
//               placeholder="Confirm password"
//               value={formData.confirmPassword}
//               onChange={(e) =>
//                 setFormData({ ...formData, confirmPassword: e.target.value })
//               }
//               size="lg"
//               borderRadius="lg"
//               bg="white"
//               shadow="sm"
//             />
//           </Box>
//         </VStack>

//         <Button
//           bg="linear-gradient(135deg, #059669, #10b981)"
//           color="white"
//           size="lg"
//           borderRadius="lg"
//           _hover={{
//             bg: "linear-gradient(135deg, #047857, #059669)",
//             transform: "translateY(-2px)",
//             shadow: "lg",
//           }}
//           transition="all 0.2s ease"
//           onClick={handleRegister}
//           disabled={
//             !formData.name ||
//             !formData.email ||
//             !formData.phone ||
//             !formData.password ||
//             !formData.confirmPassword
//           }
//         >
//           <HStack gap={2}>
//             <Icon as={FiCheckCircle} />
//             <Text>Create Account</Text>
//           </HStack>
//         </Button>

//         <Text textAlign="center" fontSize="sm" color="gray.600">
//           Already have an account?{" "}
//           <Button
//             variant="ghost"
//             colorScheme="green"
//             size="sm"
//             onClick={onSwitchToLogin}
//           >
//             Sign In
//           </Button>
//         </Text>
//       </VStack>
//     </Box>
//   );
// };
